/**
 * @generated SignedSource<<cf258d91c728cf26dddc19460a6b1693>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AggregateLevel = "YEAR" | "MONTH" | "DAY" | "%future added value";
export type FinancialAggregatedNumber = "actualRevenue" | "billableActualTimeAndExpenses" | "nonBillableActualTimeAndExpenses" | "allActualTimeAndExpenses" | "actualCost" | "actualProfit" | "actualRevenueProfit" | "actualMargin" | "actualRevenueMargin" | "plannedRevenue" | "billablePlannedTimeAndExpenses" | "nonBillablePlannedTimeAndExpenses" | "allPlannedTimeAndExpenses" | "plannedCost" | "plannedProfit" | "plannedRevenueProfit" | "plannedMargin" | "plannedRevenueMargin" | "remainingRevenue" | "billableForecastTimeAndExpensesToComplete" | "nonBillableForecastTimeAndExpensesToComplete" | "allForecastTimeAndExpensesToComplete" | "remainingCost" | "forecastCostToComplete" | "remainingProfit" | "forecastProfitToComplete" | "forecastRevenueProfitToComplete" | "remainingMargin" | "forecastMarginToComplete" | "forecastRevenueMarginToComplete" | "forecastRevenue" | "billableTotalTimeAndExpensesAtCompletion" | "nonBillableTotalTimeAndExpensesAtCompletion" | "allTotalTimeAndExpensesAtCompletion" | "forecastCost" | "totalCostAtCompletion" | "forecastProfit" | "totalProfitAtCompletion" | "totalRevenueProfitAtCompletion" | "forecastMargin" | "totalMarginAtCompletion" | "totalRevenueMarginAtCompletion" | "baselineRevenue" | "baselineTimeAndExpenses" | "baselineCost" | "baselineProfit" | "baselineMargin" | "baselineVsActualRevenue" | "baselineVsActualRevenueRecognition" | "baselineVsBillableActualTimeAndExpenses" | "baselineVsActualCost" | "baselineVsActualProfit" | "baselineVsActualMargin" | "baselineVsActualRevenueProfit" | "baselineVsActualRevenueMargin" | "baselineVsForecastRevenue" | "baselineVsBillableTotalTimeAndExpensesAtCompletion" | "baselineVsAllActualValueOfService" | "baselineVsAllProjectedValueOfService" | "estimatedVsAllActualValueOfService" | "estimatedVsAllProjectedValueOfService" | "baselineVsForecastCost" | "baselineVsTotalCostAtCompletion" | "baselineVsTotalRevenueAtCompletion" | "baselineVsForecastProfit" | "baselineVsTotalProfitAtCompletion" | "baselineVsTotalMarginAtCompletion" | "baselineVsTotalRevenueProfitAtCompletion" | "baselineVsTotalRevenueMarginAtCompletion" | "baselineMinutes" | "planVsActualRevenue" | "planVsActualRevenueRecognition" | "planVsBillableActualTimeAndExpenses" | "planVsActualCost" | "planVsActualProfit" | "planVsActualMargin" | "planVsActualRevenueProfit" | "planVsActualRevenueMargin" | "planVsForecastRevenue" | "planVsForecastCost" | "planVsForecastProfit" | "planVsTotalBillableTimeAndExpensesAtCompletion" | "planVsTotalRevenueAtCompletion" | "planVsTotalCostAtCompletion" | "planVsTotalMarginAtCompletion" | "planVsTotalProfitAtCompletion" | "planVsTotalRevenueMarginAtCompletion" | "planVsTotalRevenueProfitAtCompletion" | "recognitionLockedRevenue" | "registeredMinutes" | "billableActualMinutes" | "nonBillableActualMinutes" | "remainingMinutes" | "forecastTimeToComplete" | "forecastMinutes" | "totalTimeAtCompletion" | "scopeApprovedMinutes" | "scopeTotalMinutes" | "allocationMinutes" | "invoiced" | "paid" | "accruedDeferred" | "baselineVsRegisteredMinutes" | "baselineVsForecastMinutes" | "baselineVsTotalTimeAtCompletion" | "registeredVsScopeApprovedMinutes" | "scopeApprovedVsRegisteredMinutes" | "forecastVsScopeApprovedMinutes" | "totalTimeAtCompletionVsScopeApprovedMinutes" | "scopeApprovedVsForecastMinutes" | "scopeApprovedVsTotalTimeAtCompletion" | "retainerPeriodTargetMinutes" | "retainerPeriodTargetPrice" | "billableTime" | "recognitionPercentage" | "recognitionAmount" | "surplus" | "surplusPercentage" | "estimatedCost" | "recognitionProfit" | "recognitionProfitPercentage" | "recognitionActualProfit" | "recognitionActualProfitPercentage" | "recognitionLockedProfit" | "recognitionLockedProfitPercentage" | "recognitionForecastRevenue" | "totalRevenueRecognition" | "estimatedCostPercentage" | "expenseRevenuePercentage" | "expenseCostPercentage" | "recognitionOpenRevenue" | "actualOpenRevenue" | "actualLockedRevenue" | "totalActualRevenueRecognition" | "forecastOpenRevenueToComplete" | "forecastLockedRevenueToComplete" | "totalForecastRevenueToComplete" | "suggestedRevenue" | "suggestedRevenuePercentage" | "suggestedProfit" | "suggestedProfitPercentage" | "projectedTotalRevenueVsProjectedTotalBillableValueOfService" | "projectedTotalRevenueVsProjectedTotalValueOfService" | "retainerPeriodRolloverMinutes" | "retainerPeriodRolloverPrice" | "%future added value";
export type GLOBAL_FILTER_CONTEXT = "PROJECTS" | "PEOPLE" | "TASKS" | "TIME_REGS" | "INVOICES" | "SKILLS" | "LABELS" | "PLACEHOLDERS" | "RESOURCES" | "%future added value";
export type GLOBAL_FILTER_FIELD = "COMPANY_TASK_ID" | "NAME" | "STATUS" | "PROJECT_STATUS" | "PROJECT_GROUP_STATUS" | "PROJECT_PHASE" | "PROJECT_SPRINT" | "PROJECT_GROUP_SPRINT" | "DESCRIPTION" | "REMAINING" | "TIME_REGS" | "FORECAST" | "TASK_APPROVED" | "START_DATE" | "START_DATE_PROJECT" | "END_DATE" | "END_DATE_PROJECT" | "START_DATE_TIME_REG" | "PHASE_TIME_REG" | "END_DATE_TIME_REG" | "PROJECT_TIME_REG" | "ROLE_TIME_REG" | "TEAM_TIME_REG" | "DEPARTMENT_TIME_REG" | "INTERNAL_TIME_REG" | "TIME_OFF_TIME_REG" | "BILLABLE_TIME_REG" | "NON_PROJECT_TIME_REG" | "NON_PHASE_TIME_REG" | "NON_TASK_TIME_REG" | "NON_CLIENT_TIME_REG" | "NON_DEPARTMENT_TIME_REG" | "NON_ROLE_TIME_REG" | "NON_SPRINT_TIME_REG" | "PERSON_TIME_REG" | "CLIENT_TIME_REG" | "SPRINT_TIME_REG" | "LABEL_TIME_REG" | "TASK_TIME_REG" | "CREATED_AT" | "WITH_TIME_REG" | "WITH_TASKS" | "TASK" | "TASK_LEVEL" | "UPDATED_AT" | "SET_DONE_AT" | "ASSIGNED" | "ASSIGNED_SELF" | "OWNER" | "FOLLOWER" | "LABELS" | "PROJECT_LABELS" | "ROLE" | "PROJECT" | "PROJECT_PERSON" | "CLIENT" | "PROJECT_STAGE" | "BUG" | "BLOCKED" | "BILLABLE" | "HIGH_PRIORITY" | "STARRED" | "RECENT_TIME" | "RECENT_TASK_ACTIVITY" | "RECENT_ACTIVITY" | "PHASE_CATEGORY" | "SPRINT_CATEGORY" | "DEADLINE" | "TEAM_MEMBER" | "TEAM" | "PERMISSION_LEVEL" | "CLIENT_GUEST_USERS" | "DEPENDENCIES" | "SUB_TASKS" | "TASK_HIERARCHY" | "DEPARTMENT" | "PERSON" | "NO_CONTACT" | "APPROVAL_STATUS" | "INTERNAL_TIME" | "TIME_OFF" | "PROJECT_FOLLOWER" | "PROJECT_OWNER" | "PROJECT_BUDGET_TYPE" | "PROJECT_DEFAULT_PERIOD_BUDGET_TYPE" | "RATE_CARD" | "CONTACT" | "INVOICED" | "SKILL" | "PRIORITY_LEVEL" | "PROJECT_GROUP" | "PROGRAM" | "FILTER_BY_TIME_REG_SETTINGS" | "BILL_TO" | "BILL_FROM" | "PROJECT_MANUAL_PROGRESS" | "RETAINER_PERIOD" | "PROJECT_WIN_CHANCE" | "CLIENT_CONTACT_CLIENT_ID" | "CLIENT_CONTACT_COMPANY_ID" | "CLIENT_CONTACT_ID" | "CLIENT_CONTACT_NAME" | "CLIENT_CONTACT_FIRST_NAME" | "CLIENT_CONTACT_LAST_NAME" | "CLIENT_CONTACT_EMAIL" | "CLIENT_CONTACT_STATUS" | "CLIENT_CONTACT_IS_GUEST_USER" | "PHASE" | "SPRINT" | "DELIVERABLE" | "PARENT" | "PROGRESS" | "ESTIMATE" | "CREATED" | "UPDATED" | "%future added value";
export type GLOBAL_FILTER_LOGICAL_OPERATOR = "AND" | "OR" | "%future added value";
export type GLOBAL_FILTER_OPERATOR = "IS" | "IS_NOT" | "IS_ALL" | "IS_NOT_ALL" | "CONTAINS" | "CONTAINS_NOT" | "GREATER" | "GREATER_OR_EQUAL" | "LESS" | "LESS_OR_EQUAL" | "IN" | "NOT_IN" | "ALL_IN" | "NOT_ALL_IN" | "%future added value";
export type TaskSearchQueryType = {
  filters?: ReadonlyArray<GlobalSearchFilterType | null> | null;
};
export type GlobalSearchFilterType = {
  field?: GLOBAL_FILTER_FIELD | null;
  operator?: GLOBAL_FILTER_OPERATOR | null;
  value?: ReadonlyArray<string | null> | null;
  context?: GLOBAL_FILTER_CONTEXT | null;
  filters?: ReadonlyArray<GlobalSearchFilterType | null> | null;
  logicalOperator?: GLOBAL_FILTER_LOGICAL_OPERATOR | null;
};
export type DetailsLoader_Query$variables = {
  projectId: string;
  startYear?: number | null;
  startMonth?: number | null;
  startDay?: number | null;
  endYear?: number | null;
  endMonth?: number | null;
  endDay?: number | null;
  aggregateLevel: AggregateLevel;
  aggregates: ReadonlyArray<FinancialAggregatedNumber | null>;
  searchQuery?: TaskSearchQueryType | null;
};
export type DetailsLoader_Query$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"DetailsLoader_viewer">;
  } | null;
};
export type DetailsLoader_Query = {
  variables: DetailsLoader_Query$variables;
  response: DetailsLoader_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "aggregateLevel"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "aggregates"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDay"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endMonth"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endYear"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchQuery"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDay"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startMonth"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startYear"
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "details_loader"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"details_loader\")"
},
v12 = {
  "kind": "Variable",
  "name": "aggregateLevel",
  "variableName": "aggregateLevel"
},
v13 = {
  "kind": "Variable",
  "name": "aggregates",
  "variableName": "aggregates"
},
v14 = {
  "kind": "Variable",
  "name": "endDay",
  "variableName": "endDay"
},
v15 = {
  "kind": "Variable",
  "name": "endMonth",
  "variableName": "endMonth"
},
v16 = {
  "kind": "Variable",
  "name": "endYear",
  "variableName": "endYear"
},
v17 = {
  "kind": "Variable",
  "name": "searchQuery",
  "variableName": "searchQuery"
},
v18 = {
  "kind": "Variable",
  "name": "startDay",
  "variableName": "startDay"
},
v19 = {
  "kind": "Variable",
  "name": "startMonth",
  "variableName": "startMonth"
},
v20 = {
  "kind": "Variable",
  "name": "startYear",
  "variableName": "startYear"
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v22 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currency",
    "storageKey": null
  },
  (v21/*: any*/)
],
v23 = {
  "kind": "Literal",
  "name": "convertToProjectCurrency",
  "value": true
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DetailsLoader_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "args": [
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              {
                "kind": "Variable",
                "name": "projectId",
                "variableName": "projectId"
              },
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "DetailsLoader_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v9/*: any*/),
      (v8/*: any*/),
      (v7/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "DetailsLoader_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          (v11/*: any*/),
          (v21/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": (v22/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "internalId",
                "variableName": "projectId"
              }
            ],
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v21/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useFixedPriceForBaselineRevenue",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RateCard",
                "kind": "LinkedField",
                "name": "rateCard",
                "plural": false,
                "selections": (v22/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v23/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/)
                ],
                "kind": "ScalarField",
                "name": "aggregatedFinancialNumbers",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v23/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/)
                ],
                "concreteType": "FinancialNumbers",
                "kind": "LinkedField",
                "name": "financialNumbers",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineRevenue",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineCost",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineProfit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineMargin",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsBillableActualTimeAndExpenses",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsActualCost",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsActualProfit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsActualMargin",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsActualRevenueProfit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsActualRevenueMargin",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsActualRevenue",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsActualRevenueRecognition",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsTotalRevenueAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsBillableTotalTimeAndExpensesAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsAllActualValueOfService",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsAllProjectedValueOfService",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsTotalCostAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsTotalProfitAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsTotalRevenueProfitAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsTotalRevenueMarginAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billableActualTimeAndExpenses",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineTimeAndExpenses",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "estimatedVsAllActualValueOfService",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "estimatedVsAllProjectedValueOfService",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalActualRevenueRecognition",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "allActualTimeAndExpenses",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actualRevenue",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actualCost",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actualProfit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actualMargin",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actualRevenueProfit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actualRevenueMargin",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billablePlannedTimeAndExpenses",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "allPlannedTimeAndExpenses",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plannedRevenue",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plannedCost",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plannedProfit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plannedMargin",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plannedRevenueProfit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plannedRevenueMargin",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billableForecastTimeAndExpensesToComplete",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "allForecastTimeAndExpensesToComplete",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalForecastRevenueToComplete",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastCostToComplete",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastProfitToComplete",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastMarginToComplete",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastRevenueProfitToComplete",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastRevenueMarginToComplete",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billableTotalTimeAndExpensesAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "allTotalTimeAndExpensesAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalRevenueRecognition",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalCostAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalProfitAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalMarginAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalRevenueProfitAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalRevenueMarginAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "planVsBillableActualTimeAndExpenses",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "planVsActualRevenueRecognition",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "planVsActualCost",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "planVsActualProfit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "planVsActualMargin",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "planVsActualRevenueProfit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "planVsActualRevenueMargin",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "planVsTotalBillableTimeAndExpensesAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "planVsTotalRevenueAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "planVsTotalCostAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "planVsTotalProfitAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "planVsTotalMarginAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "planVsTotalRevenueProfitAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "planVsTotalRevenueMarginAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "invoiced",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "paid",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accruedDeferred",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "registeredMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billableActualMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nonBillableActualMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "scopeApprovedMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastTimeToComplete",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalTimeAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsRegisteredMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsTotalTimeAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "registeredVsScopeApprovedMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "scopeApprovedVsRegisteredMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalTimeAtCompletionVsScopeApprovedMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "scopeApprovedVsTotalTimeAtCompletion",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "be1668f2e4657742d1ff4ebd09fb188c",
    "id": null,
    "metadata": {},
    "name": "DetailsLoader_Query",
    "operationKind": "query",
    "text": "query DetailsLoader_Query(\n  $projectId: ID!\n  $startYear: Int\n  $startMonth: Int\n  $startDay: Int\n  $endYear: Int\n  $endMonth: Int\n  $endDay: Int\n  $aggregateLevel: AggregateLevel!\n  $aggregates: [FinancialAggregatedNumber]!\n  $searchQuery: TaskSearchQueryType\n) {\n  viewer {\n    actualPersonId\n    component(name: \"details_loader\")\n    ...DetailsLoader_viewer_1ScxAw\n    id\n  }\n}\n\nfragment DetailsLoader_viewer_1ScxAw on Viewer {\n  id\n  company {\n    currency\n    id\n  }\n  project(internalId: $projectId) {\n    id\n    useFixedPriceForBaselineRevenue\n    rateCard {\n      currency\n      id\n    }\n    aggregatedFinancialNumbers(searchQuery: $searchQuery, startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, aggregateLevel: $aggregateLevel, aggregates: $aggregates, convertToProjectCurrency: true)\n    financialNumbers(searchQuery: $searchQuery, startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, convertToProjectCurrency: true) {\n      baselineRevenue\n      baselineCost\n      baselineProfit\n      baselineMargin\n      baselineVsBillableActualTimeAndExpenses\n      baselineVsActualCost\n      baselineVsActualProfit\n      baselineVsActualMargin\n      baselineVsActualRevenueProfit\n      baselineVsActualRevenueMargin\n      baselineVsActualRevenue\n      baselineVsActualRevenueRecognition\n      baselineVsTotalRevenueAtCompletion\n      baselineVsBillableTotalTimeAndExpensesAtCompletion\n      baselineVsAllActualValueOfService\n      baselineVsAllProjectedValueOfService\n      baselineVsTotalCostAtCompletion\n      baselineVsTotalProfitAtCompletion\n      baselineVsTotalRevenueProfitAtCompletion\n      baselineVsTotalRevenueMarginAtCompletion\n      billableActualTimeAndExpenses\n      baselineTimeAndExpenses\n      estimatedVsAllActualValueOfService\n      estimatedVsAllProjectedValueOfService\n      totalActualRevenueRecognition\n      allActualTimeAndExpenses\n      actualRevenue\n      actualCost\n      actualProfit\n      actualMargin\n      actualRevenueProfit\n      actualRevenueMargin\n      billablePlannedTimeAndExpenses\n      allPlannedTimeAndExpenses\n      plannedRevenue\n      plannedCost\n      plannedProfit\n      plannedMargin\n      plannedRevenueProfit\n      plannedRevenueMargin\n      billableForecastTimeAndExpensesToComplete\n      allForecastTimeAndExpensesToComplete\n      totalForecastRevenueToComplete\n      forecastCostToComplete\n      forecastProfitToComplete\n      forecastMarginToComplete\n      forecastRevenueProfitToComplete\n      forecastRevenueMarginToComplete\n      billableTotalTimeAndExpensesAtCompletion\n      allTotalTimeAndExpensesAtCompletion\n      totalRevenueRecognition\n      totalCostAtCompletion\n      totalProfitAtCompletion\n      totalMarginAtCompletion\n      totalRevenueProfitAtCompletion\n      totalRevenueMarginAtCompletion\n      planVsBillableActualTimeAndExpenses\n      planVsActualRevenueRecognition\n      planVsActualCost\n      planVsActualProfit\n      planVsActualMargin\n      planVsActualRevenueProfit\n      planVsActualRevenueMargin\n      planVsTotalBillableTimeAndExpensesAtCompletion\n      planVsTotalRevenueAtCompletion\n      planVsTotalCostAtCompletion\n      planVsTotalProfitAtCompletion\n      planVsTotalMarginAtCompletion\n      planVsTotalRevenueProfitAtCompletion\n      planVsTotalRevenueMarginAtCompletion\n      invoiced\n      paid\n      accruedDeferred\n      baselineMinutes\n      registeredMinutes\n      billableActualMinutes\n      nonBillableActualMinutes\n      scopeApprovedMinutes\n      forecastTimeToComplete\n      totalTimeAtCompletion\n      baselineVsRegisteredMinutes\n      baselineVsTotalTimeAtCompletion\n      registeredVsScopeApprovedMinutes\n      scopeApprovedVsRegisteredMinutes\n      totalTimeAtCompletionVsScopeApprovedMinutes\n      scopeApprovedVsTotalTimeAtCompletion\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cad1bfc272a45f04b77a6137fae60eaf";

export default node;
